import Dashboard from './dashboard';
//import TiersRoutes from './tiers';
import ArticleStockRoutes from './article_stock';
//import CatalogueRoutes from './catalogue';
import DemandeRoutes from './demande';
import ExpressionBesoinRoutes from './expression-besoin';
import CommandeRoutes from './commande';

//import AppelOffreRoutes from './appel_offre';
//import ContratRoutes from './contrat';
import BudgetRoutes from './budget';
import AbonnementRoutes from './abonnement';
import NoteFraisRoutes from './note-frais';
import SourcingRoutes from './sourcing';

export default [
  ...Dashboard,
  //...TiersRoutes,
  ...ArticleStockRoutes,
  //...CatalogueRoutes,
  ...DemandeRoutes,
  ...ExpressionBesoinRoutes,
  //...AppelOffreRoutes,
  ...CommandeRoutes,
  //...ContratRoutes,
  ...BudgetRoutes,
  ...AbonnementRoutes,
  ...NoteFraisRoutes,
  ...SourcingRoutes,
];
